// Fallback mock data — used only when the API is unavailable and localStorage cache is empty.
// All values are empty arrays so the app starts clean; real data loads from the backend.
import type { User, Task, Project, WorkLogEntry, Material } from "../types";

export const mockUsers: User[] = [];
export const mockProjects: Project[] = [];
export const mockTasks: Task[] = [];
export const mockWorkLogs: WorkLogEntry[] = [];
export const mockMaterials: Material[] = [];

// Revenue summary — kept for type compatibility; not used in production.
export const mockCompanyRevenue = {
  totalRevenue: 0,
  totalExpenses: 0,
  netProfit: 0,
  monthlyData: [],
};
